var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M473.655,88.276H38.346c-21.177,0-38.345,17.167-38.345,38.345v73.471h511.998v-73.508 C511.979,105.424,494.82,88.276,473.655,88.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M512,311.908H0.001v73.471c0,21.177,17.167,38.345,38.345,38.345h435.309 c21.165,0,38.324-17.148,38.344-38.307v-73.508H512V311.908z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 200.09,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 111.81
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M95.398,233.164l5.247,11.381l12.169-2.994c0.76-0.186,1.389,0.602,1.038,1.302l-5.626,11.198 l9.928,7.648c0.62,0.478,0.395,1.462-0.371,1.623l-12.263,2.583l0.211,12.531c0.013,0.782-0.897,1.22-1.5,0.723l-9.665-7.977 l-9.665,7.977c-0.604,0.498-1.513,0.06-1.5-0.723l0.211-12.531l-12.263-2.583c-0.766-0.161-0.99-1.145-0.371-1.623l9.928-7.648 l-5.626-11.198c-0.351-0.7,0.278-1.489,1.038-1.302l12.169,2.994l5.247-11.381C94.061,232.454,95.072,232.454,95.398,233.164z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 194.21,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 15.01
  }), /*#__PURE__*/React.createElement("rect", {
    y: 302.79,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 15.01
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M233.2,252.388L13.055,97.812c-7.999,7.028-13.054,17.325-13.054,28.809v258.758 c0,11.484,5.055,21.781,13.054,28.809L233.2,259.613C235.704,257.855,235.704,254.146,233.2,252.388z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M73.561,214.847l19.831,20.297l25.624-12.192c3.317-1.579,6.735,1.974,5.03,5.228l-13.175,25.132 l19.513,20.602c2.527,2.667,0.204,7.016-3.418,6.399l-27.973-4.765l-13.564,24.925c-1.756,3.227-6.61,2.361-7.142-1.273 l-4.114-28.077l-27.896-5.197c-3.612-0.673-4.288-5.556-0.995-7.186l25.432-12.588l-3.678-28.138 C66.559,214.371,70.993,212.22,73.561,214.847z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSs);
export default __webpack_public_path__ + "static/media/ss.5a67e861557f689974405b69eca59fef.svg";
export { ForwardRef as ReactComponent };